import { HazardCategory } from 'src/app/enums/hazardCategory.enum';

/**
 * DASH-3168: the set of behaviours the risk-register grid switches on, selected by the active
 * hazard-category tab. Replaces the single `isPsychologicalHazard` boolean and its ~20 branches:
 * Psychosocial gets the {@link MATRIX_CAPABILITY_PROFILE}, every other category gets the
 * {@link STANDARD_CAPABILITY_PROFILE}. Adding a category never adds another boolean — it just maps
 * to one of the two profiles.
 */
export interface RiskRegisterCapabilityProfile {
    /**
     * Primary cell score is the persisted Health Risk Score, independent of the exposure view mode
     * (the psychosocial matrix). Standard categories derive the cell from the selected view mode.
     */
    usesHealthRiskScore: boolean;
    /** Cells are clickable and open the risk-register details popup. */
    opensDetailsPopup: boolean;
    /** The Risk Scoring bulk action and the per-cell health-score edit are available. */
    allowsRiskScoring: boolean;
    /**
     * Quantitative/qualitative exposure behaviours: the view-mode selector, the consequence-rating
     * header, the exposure/likelihood value lines, the residual block, and the Change Method /
     * Change Consequence Rating bulk actions.
     */
    usesExposureAssessment: boolean;
}

/** Psychosocial: the health-risk matrix. */
export const MATRIX_CAPABILITY_PROFILE: RiskRegisterCapabilityProfile = {
    usesHealthRiskScore: true,
    opensDetailsPopup: false,
    allowsRiskScoring: true,
    usesExposureAssessment: false,
};

/** Chemical / Physical / Biological: the quantitative-or-qualitative exposure grid. */
export const STANDARD_CAPABILITY_PROFILE: RiskRegisterCapabilityProfile = {
    usesHealthRiskScore: false,
    opensDetailsPopup: true,
    allowsRiskScoring: false,
    usesExposureAssessment: true,
};

export function getRiskRegisterCapabilityProfile(
    category: HazardCategory,
): RiskRegisterCapabilityProfile {
    return category === HazardCategory.Psychosocial
        ? MATRIX_CAPABILITY_PROFILE
        : STANDARD_CAPABILITY_PROFILE;
}
